import Dialog from './Dialog';
import DialogActions from './DialogActions';
import DialogContent from './DialogContent';
import DialogContentText from './DialogContentText';
import DialogTitle from './DialogTitle';
import DialogClose from './DialogClose';

export type { DialogProps } from './Dialog';
export type { DialogActionsProps } from './DialogActions';
export type { DialogContentProps } from './DialogContent';
export type { DialogContentTextProps } from './DialogContentText';
export type { DialogTitleProps } from './DialogTitle';
export type { DialogCloseProps } from './DialogClose';

export { DialogActions, DialogContent, DialogContentText, DialogTitle, DialogClose };
export default Dialog;
